"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _button = _interopRequireDefault(require("../../core/button"));
var _row = _interopRequireDefault(require("../../core/row"));
var _input = _interopRequireDefault(require("../../core/input"));
var _editableField = _interopRequireDefault(require("../../core/editable-field"));
var _dragHandle = _interopRequireDefault(require("../../core/drag-handle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_dragHandle.default, null);
class EntryTypeRow extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, name) => {
      this.props.onUpdate(this.props.entryType.id, name, value);
    });
    _defineProperty(this, "_onToggleExpired", () => {
      this.props.onUpdate(this.props.entryType.id, 'isExpired', !this.props.entryType.isExpired);
    });
  }
  render() {
    const entryType = this.props.entryType;
    const canEdit = !entryType.isExpired;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: entryType.id
    }, _ref, /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entryType.id), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      value: entryType.description,
      onChange: this._onChange,
      type: "text",
      name: "description",
      maxLength: 40,
      required: true
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      className: "text-xs-right",
      type: "Integer",
      name: "priority",
      value: entryType.priority,
      onChange: this._onChange,
      maxlength: 3
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      className: "text-xs-right",
      type: "Integer",
      name: "overrideBibAdjuster",
      value: entryType.overrideBibAdjuster,
      onChange: this._onChange,
      maxlength: 5
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      type: "text",
      name: "siwiCode",
      value: entryType.siwiCode,
      onChange: this._onChange,
      maxlength: 10
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, !entryType.openForOnlineEntryLeadTimeOverride ? null : /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      type: "Checkbox",
      name: "canPreRegister",
      checked: entryType.canPreRegister,
      onChange: this._onChange
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      className: "text-xs-right",
      type: "Integer",
      name: "openForOnlineEntryLeadTimeOverride",
      value: entryType.openForOnlineEntryLeadTimeOverride,
      onChange: this._onChange,
      maxlength: 3
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      className: "text-xs-right",
      type: "Integer",
      name: "closedForOnlineEntryLeadTimeOverride",
      value: entryType.closedForOnlineEntryLeadTimeOverride,
      onChange: this._onChange,
      maxlength: 3
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: canEdit,
      className: "text-xs-right",
      type: "Integer",
      name: "lateFeesLeadTimeOverride",
      value: entryType.lateFeesLeadTimeOverride,
      onChange: this._onChange,
      maxlength: 3
    }), ' '), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "link",
      size: "sm",
      onClick: this._onToggleExpired
    }, entryType.isExpired ? 'Restore' : 'Mark as expired')));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(EntryTypeRow, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('EntryType.set', {
      id,
      field,
      value
    });
  }
}));